import { environnement } from "configs/environnement";
import api from "./api";
import { IAuditLogResponseDTO } from "models/church.types";

const BASE_URL = `${environnement.baseURL}/audit-logs`;

export const AuditService = {
  getAuditLogs: async (page: number, size: number, userId?: string) => {
    const response = await api.get<IAuditLogResponseDTO[]>(`${BASE_URL}/list`, {
      params: {
        page: page,
        size: size,
        userId: userId || undefined,
      },
    });

    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
